import Loader from 'components/Loader'
import TopLevelModals from 'components/TopLevelModals'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { lazy, Suspense, useEffect, useState } from 'react'
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom'

import ErrorBoundary from '../components/ErrorBoundary'
import Header from '../components/Header'
import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import Buy from './Buy'
import Faq from './Faq'
import Home from './Home'
import Referral from './Referral'
import { RedirectPathToSwapOnly } from './Swap/redirects'

const Vote = lazy(() => import('./Vote'))

export default function App() {
  const location = useLocation()

  const [referrerAddress, setReferrerAddress] = useState<string | null>('')
  const { account } = useActiveWeb3React()

  useEffect(() => {
    const param = location.search
    // console.log(param)
    if (param.includes('?ref')) {
      const refer = param.split('=')[1]
      // console.log(refer)
      setReferrerAddress(refer)
      //  @ts-ignore
      localStorage.setItem('micreferral', refer)
    }
  }, [])

  return (
    <ErrorBoundary>
      <BrowserRouter>
        {/* <Route component={GoogleAnalyticsReporter} />
        <Route component={DarkModeQueryParamReader} />
        <Route component={ApeModeQueryParamReader} /> */}
        <Web3ReactManager>
          <>
            {location.pathname != 'referral' && <Header />}
            <Popups />
            <TopLevelModals />
            <Suspense fallback={<Loader />}>
              <Switch>
                <Route exact strict path="/" component={Home} />
                <Route exact strict path="/buy" component={Buy} />
                <Route exact strict path="/faq" component={Faq} />

                <Route exact strict path="/referral" component={Referral} />

                <Route component={RedirectPathToSwapOnly} />
              </Switch>
            </Suspense>
            {/* <Marginer /> */}
            <p style={{ bottom: '0px', color: 'white' }} className="m-2">
              Copyright © 2022 Meta Invisible Cloak, All rights reserved. MIC NFT LLC <br />{' '}
              support@metainvisiblecloak.com
            </p>
          </>
        </Web3ReactManager>
      </BrowserRouter>
    </ErrorBoundary>
  )
}
